export enum TokenType {
    AppComunication = 'App',
    ChangePassword = 'Pwd',
    LoginSucceeded = 'Login',
    Code2FA = '2FA',
    RefreshToken = 'Refresh',
    UpdatePrivacy = "UpdatePrivacy",
    NewUser = "NewUser"
}
